import {Component} from 'react';
import {Table} from 'react-bootstrap';

import myAjax from '../global/libs/myAjax.js';
import CONFIG from '../global/libs/CONFIG.js';
import {DEPT_DATA} from '../global/libs/departmentUtil.js';
import PropTypes from 'prop-types';
import './Common.css';
import './QuestionPanel.css'

/**
 *
 * Component structure:
 *

    QuestionPanel
    |-- QuestionPanelHeader
    |-- QuestionPanelBody

 */

class QuestionPanel extends Component {
  // props: askQuestion, updateJumbotronInput
  constructor(props) {
    super(props);

    this.state = {
      pageLimit: 100, // max number of q displayed in single page
      pageCount: 1, // count of pages
      activePage: 1, // current active page
      all_q_list: [], // all list of new created questions (limit)
      qList: [] // list of questions for display
    };

    this.getQList = this.getQList.bind(this);
    this.changeActivePage = this.changeActivePage.bind(this);

    this.getQList(); // load initial q list
  }

  changeActivePage(nextPage, callback) {
    this.setState({activePage: nextPage}, callback);
  }

  getQList() {
    const {all_q_list, pageLimit, activePage} = this.state;
    let offset = pageLimit * (activePage - 1);

    if (all_q_list.length === 0) {
      var category_group;
      if (CONFIG.ENABLE_MULTI_DEPT && DEPT_DATA.length > 0) {
        category_group = DEPT_DATA[0].dept;
      }
      const ajaxData = {
        ordering: '-datetime_modified',
        category_group: category_group
      };
      myAjax('/api/qa_data/q_list/', ajaxData, 'GET').done((data) => {
        let all_q_list = data;
        let q_list_for_disp = all_q_list.slice(offset, offset + pageLimit);
        this.setState({
          all_q_list: all_q_list,
          qList: q_list_for_disp,
          pageCount: Math.ceil(all_q_list.length / pageLimit)
        });
      });
    } else {
      let q_list_for_disp = all_q_list.slice(offset, offset + pageLimit);
      this.setState({
        qList: q_list_for_disp
      });
    }
  }

  render() {
    const {askQuestion, updateJumbotronInput} = this.props;
    let {qList, pageCount, activePage} = this.state;

    return (
      <div>
        <QuestionPanelHeader
          pageCount={pageCount}
          activePage={activePage}
          changeActivePage={this.changeActivePage}
          getQList={this.getQList}
        />
        <QuestionPanelBody qList={qList} askQuestion={askQuestion} updateJumbotronInput={updateJumbotronInput} />
        <hr />
      </div>
    );
  }
}

class QuestionPanelHeader extends Component {
  constructor(props) {
    super(props);

    this.handlePageSelect = this.handlePageSelect.bind(this);
  }

  handlePageSelect(eventKey) {
    let {changeActivePage, getQList} = this.props;

    changeActivePage(eventKey, getQList);
  }

  render() {
    let tdTitle = <td style={{fontSize: 'x-large', borderTop: 'none', width: 115}}>質問一覧</td>;

    return (
      <table className="table">
        <tbody>
          <tr>
            {tdTitle}
            {/* {pagination} */}
          </tr>
        </tbody>
      </table>
    );
  }
}

class QuestionPanelBody extends Component {
  // props: askQuestion, updateJumbotronInput, qList
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const {updateJumbotronInput, askQuestion} = this.props;
    const clickedQuestion = e.target.id;
    updateJumbotronInput(clickedQuestion, askQuestion, true);
  }

  render() {
    const {qList} = this.props;

    const thread = (
      <tr>
        <th style={{width: '40%'}}>カテゴリ</th>
        <th>質問</th>
      </tr>
    );

    const trs = qList.map(
      function (qItem, idx) {
        return (
          <tr
            style={{wordBreak: 'break-all', borderBottom: 'var(--wistalk-border-style)'}}
            key={'qaItem' + idx}
          >
            <td>{qItem['category']}</td>
            <td>
              <a
                className='question_text'
                role="button"
                style={{color: '#333333'}}
                id={qItem['question']}
                onClick={this.handleClick}
                dangerouslySetInnerHTML={{__html: qItem['question']}}
              ></a>
            </td>
          </tr>
        );
      }.bind(this)
    );

    return (
      <div
        className="bodycontainer scrollable"
        style={{
          marginTop: '-10px',
          maxHeight: '390px',
          width: '100%',
          overflowY: 'auto'
        }}
      >
        <Table hover>
          <tbody>
            {thread}
            {trs}
          </tbody>
        </Table>
      </div>
    );
  }
}

QuestionPanel.propTypes = {
  askQuestion: PropTypes.func.isRequired,
  updateJumbotronInput: PropTypes.func.isRequired,
  changeActivePage: PropTypes.func,
  getQList: PropTypes.func
};

QuestionPanelBody.propTypes = {
  askQuestion: PropTypes.func.isRequired,
  updateJumbotronInput: PropTypes.func.isRequired,
  qList: PropTypes.array
};
QuestionPanelHeader.propTypes = {
  pageCount: PropTypes.number,
  activePage: PropTypes.number,
  changeActivePage: PropTypes.func,
  getQList: PropTypes.func
};

export default QuestionPanel;
